import React from 'react';
import { withRouter } from 'react-router-dom';

let BlogPost = withRouter(({ heading, h2Heading, history, blog, type, id }) => (
  <div className="blog__grid-item">
    {heading ? (
      <h2
        className="sub-featured-heading"
        onClick={() => history.push(`/blog/${type}`)}
      >
        {heading}
      </h2>
    ) : null}
    <div onClick={() => history.push(`/blog/${type}/${id}`)}>
      <img src={blog.img} alt={blog.imgAlt} />
      {h2Heading ? <h2>{blog.title}</h2> : <h3>{blog.title}</h3>}
      <p>{blog.tldr}</p>
    </div>
  </div>
));

export default BlogPost;
